import * as React from 'react';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import Bs4GenericField from './Bs4GenericField';
import bs4OptionBinding from '../../Bs4OptionBinding'
import Bs4Kartoteka from '../../Bs4Kartoteka';
import Bs4ReportGeneric from '../../Bs4Report/Bs4ReportGeneric';

export default class Bs4Kanban extends Bs4GenericField {  

  initializeFormField() {
    super.initializeFormField()

    this.bs4Option = bs4OptionBinding({
      bs4Source: 'Bs4Kanban',
      bs4KartotekaId: this.bs4KartotekaId,
      optionId: this.props.field.idSourceReport,
      optionType:'51',
      formId: this.props.field.formId,
      bs4flexframe: this.props.bs4flexframe,
    });
    
    this.bs4Option.bs4Grid.on(Bs4ReportGeneric.ROW_EDITED, (row) => {
      this.trigger(Bs4GenericField.CHANGE_DIRTY, this, this.isDirty());
    })
  }
  
  getValue() {
    return null;
  }

  resetOriginalValue() {    
    this.trigger(Bs4GenericField.CHANGE_DIRTY, this, this.isDirty());
  }  

  isDifferentValues (oldValue, newVaue) {    
    return false;
  }

  clear() {
    
  }

  ViewComponentField = (props) => {
    const formField = this;
    return (
      <FormControl id={props.inputId} fullWidth sx={{height: props.bs4flexframe ? '100%' : 'auto'}} >
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <formField.bs4Option.ViewComponent/>       
      </FormControl>
    );
  }
}